/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Embed_TitleInputs */

const en_admin_embed_title = /** @type {(inputs: Admin_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed widgets on external websites`)
};

const de_admin_embed_title = /** @type {(inputs: Admin_Embed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widgets auf externen Webseiten einbetten`)
};

/**
* | output |
* | --- |
* | "Embed widgets on external websites" |
*
* @param {Admin_Embed_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_embed_title = /** @type {((inputs?: Admin_Embed_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Embed_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_embed_title(inputs)
	return en_admin_embed_title(inputs)
});